<template>
  <!-- hidden -->
  <input :value="type" :name="scopeToName([...scope, 'type'])" type="hidden">
  <input :value="id" :name="scopeToName([...scope, 'id'])" type="hidden">
  <input :value="position" :name="scopeToName([...scope, 'position'])" type="hidden">
  <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
    <ul>
      <li v-for="[attribute, attribute_errors] in Object.entries(errors)" :key="`error_msg_${attribute}_${attribute_errors[0]?.message}`">
        {{ $t(`activerecord.attributes.candidacy/form_item.${attribute}`) }}:
        <ul>
          <li v-for="({message}) in attribute_errors" :key="`error_mgs_text_${message}`">{{message}}</li>
        </ul>
      </li>
    </ul>
  </div>
  <slot></slot>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { humanize, scopeToName } from "@/lib/candidacy/form_builder/utils";
import type { EveryBuildableItem, BuildableItemErrors, BuildableItemType, PropType } from "@/types";

export default defineComponent({
  name: "OrderedItem",
  methods: { humanize, scopeToName },
  props: {
    initialItem: {
      type: Object as PropType<EveryBuildableItem>,
      required: true,
    },
    position: {
      type: Number,
      required: true,
    },
    scope: {
      type: Array as PropType<string[]>,
      default: []
    },
  },
  data: ({ initialItem }) => ({
    id: initialItem.id as number,
    type: initialItem.type as BuildableItemType,
    errors: initialItem.errors || {} as BuildableItemErrors,
  }),
});
</script>
